import { render, staticRenderFns } from "./HeaderDekraLogo.vue?vue&type=template&id=2e421e98&scoped=true"
import script from "./HeaderDekraLogo.vue?vue&type=script&lang=ts"
export * from "./HeaderDekraLogo.vue?vue&type=script&lang=ts"
import style0 from "./HeaderDekraLogo.vue?vue&type=style&index=0&id=2e421e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e421e98",
  null
  
)

export default component.exports